module.exports = __webpack_public_path__ + "f14fdbf1344ae0dba15b9aa549df1ddd.svg";